// Simplified port of hs-monorepo's frame_polling_controller (without the
// frame_reload_action dependency): reload a turbo-frame after a timeout.
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    frameId: String,
    timeout: { type: Number, default: 5_000 },
    reloadUrl: String,
  };

  connect() {
    this.timeoutId = setTimeout(() => this.reloadFrame(), this.timeoutValue);
  }

  disconnect() {
    clearTimeout(this.timeoutId);
  }

  reloadFrame() {
    const frame = document.getElementById(this.frameIdValue);
    if (!frame) return;

    if (this.hasReloadUrlValue && frame.src !== this.reloadUrlValue) {
      frame.src = this.reloadUrlValue;
    } else if (frame.src) {
      frame.reload();
    }
  }
}
